import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { ChangeEvent, FC } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useAppSelector, useActions } from 'store/hooks'
import { TextField } from 'ui'
import { ProductParamsIcon } from 'widget/ProductParamsIcon/ProductParamsIcon'

import style from './InputNumber.module.scss'

interface IInputNumber {
  data: orderApiSpace.ProductParamData
  productId: number
}

export const InputNumber: FC<IInputNumber> = ({ data, productId }) => {
  const { control } = useForm()
  const { setParamOrder } = useActions()

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setParamOrder({
      id: data.id,
      name: data.name,
      iconUrl: data.iconUrl,
      type: data.typeCode,
      productId: productId,
      value: e.target.value.replace(/[^0-9]/g, ''),
    })
  }
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const params = useAppSelector(
    state => state.orderForm.forms[currentEditForm].params,
  )
  const param = params.find(item => item.id === data.id)

  return (
    <Controller
      name={`${data.id}_${data.name}`}
      control={control}
      render={({ field }) => (
        <div className={style.inputTextWithIcon}>
          <ProductParamsIcon url={data.iconUrl} name={data.name} />

          <TextField
            {...field}
            inputProps={{
              enterKeyHint: 'enter',
              inputMode: 'numeric',
              autocomplete: 'off',
              maxLength: 15,
            }}
            label={data.name}
            className={style.textField}
            onChange={onChangeHandler}
            value={param?.value || ''}
            data-testid={`param-input-number-${data.id}`}
          />
        </div>
      )}
    />
  )
}
